import Index from 'src/pages/CollectiveBookings/Index.vue'
import Edit from 'src/pages/CollectiveBookings/Edit.vue'
import Show from 'src/pages/CollectiveBookings/Show.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/collective-bookings',
    name: 'Sammelbuchungen',
    component: Index,
    meta: auth
  },
  {
    path: '/collective-bookings/:id',
    name: 'Sammelbuchung anzeigen',
    component: Show,
    meta: auth
  },
  {
    path: '/collective-bookings/:id/edit',
    name: 'Sammelbuchung bearbeiten',
    component: Edit,
    meta: auth
  }
]
